
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import * as ST from './styled';

interface IProps {
    labelText?: string,
    qrPath?: string,
    isLazy?: boolean,
    className?: string,
}

const MobileStoreQrLabel = ({
    labelText = 'Скачать по QR',
    qrPath,
    isLazy = true,
    className,
}: IProps): JSX.Element => {
    return (
        <ST.QrLabelBlock className={className}>
            <ST.QrBlock>
                {qrPath
                    ? <ST.QrCode
                        src={qrPath}
                        alt='QR-код для скачивания приложения'
                        visibleByDefault={isLazy}
                        data-test='qr-prop'
                    />
                    : <WebpImage urlWebp={'/static/images/service/agent/QrCode.webp'}>
                        <ST.QrCode
                            src='/static/images/service/agent/QrCode.png'
                            alt='QR-код для скачивания приложения'
                            data-test='qr-default'
                        />
                    </WebpImage>
                }
            </ST.QrBlock>
            <ST.LabelBlock data-test='qr-label'>{labelText}</ST.LabelBlock>
        </ST.QrLabelBlock>
    );
};

export default MobileStoreQrLabel;
